import {AiToolImpl} from "@me8eon/aiclient";
import {getGraphApi, TeamGraphApiResponse} from "../model/api";
import { JwtTokenFn } from "@me8eon/authentication";

type ToolArgs = {
    id: string
}

type ToolImpl = AiToolImpl<ToolArgs>

type Tool = (tokenFn: JwtTokenFn) => ToolImpl

type Executor = (tokenFn: JwtTokenFn) => ToolImpl['execute']

const executor: Executor = (tokenFn) => async (_args, input) => {
    const {id} = input;

    const path = `users/${id}/`;

    const queryParams = {
        "$expand": "directReports($levels=1;$select=id,displayName,jobTitle,mail,userPrincipalName)"
    }

    const response = await getGraphApi<TeamGraphApiResponse>(path, tokenFn, queryParams)

    const hits = response.data;
    if (!hits.directReports || hits.directReports.length === 0) return {
        value: "No direct reports found."
    }

    const filteredReports =  hits.directReports.filter(report => {
        return report.mail && report.mail !== hits.mail; // filter out self reference if exists
    });
    const directReportsInfo = filteredReports.map(report => `Name: ${report.displayName}\nEmail: ${report.mail}\nKID: ${report.userPrincipalName}`).join("\n\n");

    return {
        value: `Here is the direct reports info found:\n\n${directReportsInfo}`
    }
}

export const SearchTeamToolImplGenerator: Tool = (tokenFn) => {
    return {
        type: "graph_api",
        toolDefn: {
            type: 'function',
            name: "search_team",
            description: "This tool fetches a person's direct reports ONLY by their principal identifier from GraphAPI platform. It returns a list of person's direct reports. If no direct reports are found, it returns 'No direct reports found.'.",
            parameters: {
                type: "object",
                required: ["id"],
                additionalProperties: false,
                properties: {
                    id: {
                        type: "string",
                        description: "The principal identifier of the person to find their direct reports.",
                    }
                },
            },
        },
        execute: executor(tokenFn),
    }
}
